<div class="form-horizontal key-form m-3">
  <p-tabs value="zertifikate">
    <p-tablist>
      <p-tab value="zertifikate">
        Zertifikate
      </p-tab>
      <p-tab value="private-schluessel">
        Private Schlüssel
      </p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel value="zertifikate" >
        <app-certificate-list></app-certificate-list>
      </p-tabpanel>
      <p-tabpanel value="private-schluessel" >
        <app-private-key-list></app-private-key-list>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
